export const MESSAGE_CHARACTER_LIMIT = 2000;
export const colors = [
    '#000000', '#333333', '#666666', '#999999', '#CCCCCC', '#FFFFFF', // Grayscale
    '#FF0000', '#FF6666', '#CC0000', '#990000', // Reds
    '#00FF00', '#66FF66', '#00CC00', '#009900', // Greens
    '#0000FF', '#6666FF', '#0000CC', '#000099', // Blues
    '#FFFF00', '#FFFF66', '#CCCC00', '#999900', // Yellows
    '#FFA500', '#FFB84D', '#FF8C00', '#CC7000', // Oranges
    '#FF00FF', '#FF66FF', '#CC00CC', '#990099', // Magentas
    '#00FFFF', '#66FFFF', '#00CCCC', '#009999', // Cyans
    '#800000', '#808000', '#008000', '#800080', '#008080', '#000080' // Extra deep tones
  ];
  